import React, { CSSProperties, ReactNode } from 'react';
import AntdResult from 'antd/lib/result';

/**
 * {@docCategory Result}
 */
export interface ResultProps {
   /**
    * Result status, determines icons and colors
    * @defaultvalue info
    */
   status?: 'success' | 'error' | 'info' | 'warning';

   /**
    * The title
    */
   title?: ReactNode;

   /**
    * The sub-title.
    */
   subTitle?: ReactNode;

   /**
    * Sets a className.
    */
   className?: string;

   /**
    * Sets styles.
    */
   style?: CSSProperties;

   /**
    * The children. Displayed under the sub-title.
    */
   children?: ReactNode;
}

export const Result = (props: ResultProps) => {
   return (
      <AntdResult
         status={props.status}
         title={props.title}
         subTitle={props.subTitle}
         extra={props.children}
         className={props.className}
         style={props.style}
      />
   );
};
